import React, { Component } from 'react';
import AdminCancellationTable from './AdminCancellationTable';

export class AdminCancellationContent extends Component {
  render() {

    return (
      <AdminCancellationTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminCancellationContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminCancellation/AdminCancellationContent.js